export function hasStoredAccessTokenSync(): boolean {
  if (typeof localStorage === "undefined") {
    return false
  }
  return !!localStorage.getItem("accessToken")
}
